import React from 'react';
import '../../styles/admin/ReportFilters.css';

const ReportFilters = ({ dateRange, setDateRange, reportType, setReportType, onExport, onPrint }) => {
  const handleDateChange = (field, value) => {
    setDateRange(prev => ({ ...prev, [field]: value }));
  };

  const setQuickRange = (days) => {
    const endDate = new Date();
    const startDate = new Date();
    startDate.setDate(startDate.getDate() - days);

    setDateRange({
      startDate: startDate.toISOString().split('T')[0],
      endDate: endDate.toISOString().split('T')[0]
    });
  };

  return (
    <div className="report-filters">
      <div className="filters-row">
        <div className="filter-group">
          <label>
            <i className="fas fa-chart-pie"></i>
            Report Type
          </label>
          <select value={reportType} onChange={(e) => setReportType(e.target.value)}>
            <option value="sales">Sales Report</option>
            <option value="products">Product Performance</option>
            <option value="inventory">Inventory Status</option>
          </select>
        </div>

        <div className="filter-group">
          <label>
            <i className="fas fa-calendar-alt"></i>
            Start Date
          </label>
          <input
            type="date"
            value={dateRange.startDate}
            onChange={(e) => handleDateChange('startDate', e.target.value)}
          />
        </div>

        <div className="filter-group">
          <label>
            <i className="fas fa-calendar-check"></i>
            End Date
          </label>
          <input
            type="date"
            value={dateRange.endDate}
            onChange={(e) => handleDateChange('endDate', e.target.value)}
          />
        </div>
      </div>

      <div className="quick-actions">
        <div className="quick-range-group">
          <label>Quick Ranges:</label>
          <div className="quick-range-buttons">
            <button onClick={() => setQuickRange(7)}>7 Days</button>
            <button onClick={() => setQuickRange(30)}>30 Days</button>
            <button onClick={() => setQuickRange(90)}>90 Days</button>
            <button onClick={() => setQuickRange(365)}>1 Year</button>
          </div>
        </div>

        <div className="action-buttons">
          <button className="export-btn" onClick={onExport}>
            <i className="fas fa-file-export"></i>
            <span>Export</span>
          </button>
          <button className="print-btn" onClick={onPrint}>
            <i className="fas fa-print"></i>
            <span>Print</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReportFilters;